import React from 'react';
import { motion } from 'framer-motion';
export function FreeSessionSection() {
  return <section className="py-20 md:py-28 lg:py-32 bg-brand-dark border-y border-brand-border" data-id="element-64">
      <div className="max-w-[1280px] mx-auto px-6 lg:px-20" data-id="element-65">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center" data-id="element-66">
          {/* Text side */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} data-id="element-67">
            <div className="inline-block border border-brand-accent bg-transparent px-4 py-1.5 rounded-[2px] mb-8" data-id="element-68">
              <span className="font-heading font-bold text-brand-accent text-sm uppercase tracking-industrial-wide" data-id="element-69">
                GRATUIT
              </span>
            </div>

            <h2 className="font-heading font-black text-2xl md:text-3xl lg:text-4xl text-brand-white uppercase tracking-industrial mb-6" data-id="element-70">
              Ai o sesiune gratuită de mentorat
            </h2>

            <p className="font-body text-lg text-brand-muted leading-relaxed mb-10 max-w-lg" data-id="element-71">
              Programează o discuție de 30 de minute cu mine, unu la unu. Vorbim
              despre situația ta, despre ce vrei să faci și îți arăt exact care
              sunt pașii pe care trebuie să îi urmezi.
            </p>

            <a href="https://wa.link/udb2nf" target="_blank" rel="noopener noreferrer" className="inline-block text-center bg-brand-accent text-brand-black font-heading font-bold uppercase tracking-industrial px-10 py-5 rounded-[4px] hover:bg-white transition-all duration-300 accent-glow-hover text-base w-full sm:w-auto" data-id="element-72">
              Programează Sesiunea Gratuită
            </a>
          </motion.div>

          {/* Photo side */}
          <motion.div initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="relative h-[350px] md:h-[420px] rounded-lg overflow-hidden border border-brand-border" data-id="element-73">
            <img src="https://images.unsplash.com/photo-1531482615713-2afd69097998?w=800&q=80&auto=format&fit=crop" alt="Sesiune de mentorat unu la unu" className="w-full h-full object-cover" data-id="element-74" />
            <div className="absolute inset-0 bg-gradient-to-l from-brand-black/50 via-brand-black/10 to-transparent" data-id="element-75" />
            {/* Decorative corners */}
            <div className="absolute top-4 right-4 w-12 h-12 border-t-2 border-r-2 border-brand-accent/40" data-id="element-76" />
            <div className="absolute bottom-4 left-4 w-12 h-12 border-b-2 border-l-2 border-brand-accent/40" data-id="element-77" />
          </motion.div>
        </div>
      </div>
    </section>;
}